// @flow

import * as React from 'react';

import { HeadlineSection, SubHeadlineSection } from '@components/Headlines';
import TeaserGroupTrio from '@components/TeaserGroupTrio';
import { withTranslation } from '@i18n';
import type { Props } from './types';

const images = [
  '../../../../../../static/images/teasers/HowItworks/Above_USP_1.jpg',
  '../../../../../../static/images/teasers/HowItworks/Above_USP_2.jpg',
  '../../../../../../static/images/teasers/HowItworks/Above_USP_3.jpg'
];
const WhyUs = ({ t }: Props): React.Node => {
  const propsTeaserGroupTrio = {
    images,
    headlines: [
      t('WhyUsTeaserList.FirstItemTitle'),
      t('WhyUsTeaserList.SecondtItemTitle'),
      t('WhyUsTeaserList.ThirdItemTitle')
    ],
    copies: [
      t('WhyUsTeaserList.FirstItemCopy'),
      t('WhyUsTeaserList.SecondtItemCopy'),
      t('WhyUsTeaserList.ThirdItemCopy')
    ]
  };

  return (
    <>
      <HeadlineSection component="h1">{t('WhyUsTeaserList.Title')}</HeadlineSection>
      <SubHeadlineSection>{t('WhyUsTeaserList.Subtitle')}</SubHeadlineSection>

      <TeaserGroupTrio {...propsTeaserGroupTrio} />
    </>
  );
};

export default withTranslation('Hospitals')(WhyUs);
